import script from "./overall.vue?vue&type=script&setup=true&lang=js"
export * from "./overall.vue?vue&type=script&setup=true&lang=js"

import "./overall.vue?vue&type=style&index=0&id=7f985f68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f985f68"]])

export default __exports__